import { useSelector } from 'react-redux';

const Permission = ({roles, children}) =>{
  const { user } = useSelector(state => state.auth)
  return (
    roles.includes(user?.role) && children
  )
}

export default Permission